module.exports = __webpack_public_path__ + "static/media/Camera19.e391d2da.jpg";